import { useState } from "react";
import { Control, FieldValues, Path } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ControlledAutocomplete } from "components/form";

import { useParkingFilterQuery } from "../hooks";

interface ParkingFilterProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
}

export const ParkingFilter = <T extends FieldValues>({ control, name }: ParkingFilterProps<T>) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);

  const { isPending, data } = useParkingFilterQuery(open);

  const zones = data?.data.zones ?? [];

  const options = zones.filter(({ number }) => Boolean(number)) ?? [];

  return (
    <ControlledAutocomplete
      sx={{ gridArea: "parking" }}
      disablePortal
      getOptionKey={(option) => option.uuid ?? ""}
      getOptionLabel={(option) => option.number ?? ""}
      isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
      options={options}
      loading={isPending}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      name={name}
      control={control}
      TextFieldProps={{ label: t("history.labels.parking") }}
    />
  );
};
